import dayjs from "dayjs";
export const CRON = {
    DEFAULT: "* * * * * ? *",
    DefaultFormFields: {
        daily: 1,
        monthly_day: 1,
        monthly_date: 1,
        monthly_series: 1,
        day_of_week: 1,
        weekday_select: [dayjs().weekday()],
        weekly: 1,
        yearly: 1,
    },
};
//# sourceMappingURL=CRON.js.map